<template>
  <div
    class="con-vs-avatar"
    :class="[$attrs.class, avatarClass]"
    :style="[$attrs.style, avatarStyle]"
    v-bind="rootAttrs"
  >
    <div
      v-if="badge && badge > 0"
      class="dot-count vs-avatar--count"
      :class="badgeClass"
      :style="badgeStyle"
    >
      {{ typeof badge !== "boolean" ? badge : null }}
    </div>
    <div v-if="src" class="con-img vs-avatar--con-img">
      <img :src="src" :alt="text" />
    </div>
    <span
      v-else
      class="vs-avatar--text notranslate"
      :class="[text ? '' : iconPack, text ? '' : icon, textClass]"
      :style="textStyle"
      :title="text"
      translate="no"
    >
      {{ text ? returnText : iconPack === "material-icons" ? icon : "" }}
    </span>
  </div>
</template>

<script>
import colorUtils from "@/assets/utils/color";

export default {
  name: "VsAvatar",
  inheritAttrs: false,
  props: {
    badge: {
      type: [Boolean, String, Number],
      default: false,
    },
    badgeColor: {
      type: String,
      default: "danger",
    },
    size: {
      type: String,
      default: null,
    },
    src: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: "person",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    textColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    },
    text: {
      type: [String, Number],
      default: null,
    },
    color: {
      type: String,
      default: "rgb(195, 195, 195)",
    },
  },
  computed: {
    rootAttrs() {
      const attrs = { ...this.$attrs };
      delete attrs.class;
      delete attrs.style;
      return attrs;
    },
    avatarClass() {
      return {
        [this.size]: Boolean(this.size),
        [`con-vs-avatar-${this.color}`]: colorUtils.isColor(this.color),
      };
    },
    avatarStyle() {
      return {
        width: this.size && /(px|em|rem|%)/.test(this.size) ? this.size : null,
        height: this.size && /(px|em|rem|%)/.test(this.size) ? this.size : null,
        background: colorUtils.isColor(this.color)
          ? null
          : colorUtils.getColor(this.color),
      };
    },
    badgeClass() {
      return {
        badgeNumber: typeof this.badge !== "boolean",
        [`dot-count-${this.badgeColor}`]: colorUtils.isColor(this.badgeColor),
      };
    },
    badgeStyle() {
      return {
        background: colorUtils.isColor(this.badgeColor)
          ? null
          : colorUtils.getColor(this.badgeColor),
      };
    },
    textClass() {
      return {
        "material-icons": !this.text,
        [`vs-avatar-text-${this.textColor}`]: colorUtils.isColor(
          this.textColor
        ),
      };
    },
    textStyle() {
      return {
        transform: `translate(-50%,-50%) scale(${this.returnScale})`,
        color: colorUtils.isColor(this.textColor)
          ? null
          : colorUtils.getColor(this.textColor),
      };
    },
    returnText() {
      const value = String(this.text);
      if (value.length <= 5) return value;

      const words = value.split(/\s/g).filter(Boolean);
      const letters =
        words.length > 1
          ? words.map((word) => word[0].toUpperCase()).join("")
          : value[0].toUpperCase();
      return letters.length > 5 ? letters[0] : letters;
    },
    returnScale() {
      if (!this.text) return 1;
      const length = this.returnText.length;
      return length <= 5 && length > 1 ? 1 / 1.5 : 1;
    },
  },
};
</script>
